import React, { useEffect, useRef } from 'react';
import './AboutMe.css';

const AboutMe = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observedElement = sectionRef.current;
    
    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('fade-in-active');
            }
        },
        { 
            threshold: 0.2,
            rootMargin: '0px 0px -50px 0px'
        }
    );

    if (observedElement) {
        observer.observe(observedElement);
    }

    return () => {
        if (observedElement) {
            observer.unobserve(observedElement);
        }
    };
  }, []);

  return (
    <section className="about-section fade-in" ref={sectionRef}>
      <div className="about-container">
        <div className="about-content">
          <h2 className="section-title">About Me</h2>
          <div className="about-grid">
            <div className="about-text">
              <p className="bio">
                I'm a passionate Full Stack Developer with expertise in building exceptional digital experiences. 
                With a background in computer science and 3+ years of hands-on experience, I specialize in creating 
                efficient, scalable, and user-friendly applications.
              </p>
              <div className="journey">
                <h3>My Journey</h3>
                <ul className="timeline">
                  <li>
                    <span className="date">2025</span>
                    <p>Frontend Developer & UI/UX Designer at Zend Fintech company</p>
                  </li>
                <li>
                    <span className="date">2024</span>
                    <p>Project Manager & Full Stack Developer at Vesen Computing Solutions</p>
                  </li>
                  <li>
                    <span className="date">2023</span>
                    <p>Senior Full Stack Developer at Dove International</p>
                  </li>
                  <li>
                    <span className="date">2022</span>
                    <p>FullStack Software Developer at KeMU Tech Innovators</p>
                  </li>
                  <li>
                    <span className="date">2021</span>
                    <p>Freelance Frontend Developer at Upwork</p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="skills-container">
              <h3>Technical Skills</h3>
              <div className="skills-grid">
                {['JavaScript', 'React', 'Node.js', 'PHP', 'AWS', 'MongoDB'].map((skill) => (
                  <div className="skill-card" key={skill}>
                    <span className="skill-name">{skill}</span>
                    <div className="skill-level"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;